import { Image } from "antd";
import React from "react";

export const ItemCertificados = ({ index, item }) => {
	return (
		<div
			className="flex flex-col laptop:flex laptop:flex-row justify-center items-center m-2 laptop:m-6"
			key={index}
		>
			<div 
            style={{
                width: "100px",
                marginBottom: "8px",
                marginRight: "8px"
            }}
            >
				<p className="font-Poppins text-smt text-yellow-300 font-semibold ">
					{item.nombre}
				</p>
				<p className="font-Poppins text-smt text-gray-200">{item.fecha}</p>
			</div>
			<div className="flex flex-col-reverse tabletbig:flex-row my-5 justify-center items-center">
				<div
					style={{
						width: "150px",
					}}
				>
					<Image src={item.picture} 
						alt={item.nombre}
						loading="lazy"
					/>
				</div>
                <div style={{
                    width: "310px"
                }}>
                    <p className="mx-3 mb-3 text font-Poppins text-gray-200">
                        {item.evento}
                    </p>
                </div>
			</div>
		</div>
	);
};
